import {get as _get} from "lodash";
import { showCookieConsentModal } from './HelpScoutModal';

export const SERVICE_HELPSCOUT = 'helpscout_beacon';
export const CATEGORY_FUNCTIONALITY = 'functionality';
const beaconId = import.meta.env.VITE_HELPSCOUT_BEACON_ID;
const isEnabled = () => {
    return !!beaconId;
};

window.BeaconOpen = function(action) {
    if(_get(window,'scriptsLoaded.helpscout')) {

        if (action !== 'openFromGoToPremium') {
            Beacon('reset')
        }

        if (action === 'openFromGoToPremium') {
            action = 'open'
        }

        window.Beacon(action)
    }
    else {
        showCookieConsentModal(window.$i18n)
    }
};

export function getHelpScoutConfig(i18n) {
    const lang = i18n.locale;
    const labels = {
        [lang]: i18n.t('tekst HelpScout Beacon (Czat wsparcia) (cookie consent)')
    };

    return {
        category: CATEGORY_FUNCTIONALITY,
        service: SERVICE_HELPSCOUT,
        config: {
            label: labels[lang] || labels['en']
        },
        cookieTable: {
            body: [
                {
                    name: "beacon_docs_session_id",
                    domain: "beaconapi.helpscout.net",
                    description: lang === 'pl' ? "Identyfikator sesji czatu HelpScout Beacon" :
                                 lang === 'ua' ? "Ідентифікатор сесії чату HelpScout Beacon" :
                                 "HelpScout Beacon chat session identifier",
                    expiration: lang === 'pl' ? "Sesja" :
                                lang === 'ua' ? "Сесія" :
                                "Session"
                },
                {
                    name: 'beacon_docs_visit',
                    domain: "beaconapi.helpscout.net",
                    description: lang === 'pl' ? "Plik cookie ustawiony przez HelpScout Beacon do śledzenia odwiedzin" :
                                 lang === 'ua' ? "Файл cookie, встановлений HelpScout Beacon для відстеження відвідувань" :
                                 "Cookie set by HelpScout Beacon for tracking visits",
                    expiration: lang === 'pl' ? "Sesja" :
                                lang === 'ua' ? "Сесія" :
                                "Session"
                }
            ]
        },
        autoClear: {
            cookies: [
                { name: /^beacon_.*/ }
            ]
        }
    };
}

export function initializeHelpScout() {

    if (!isEnabled()) {
        return;
    }

    window.Beacon = window.Beacon || function(method, options, data) {
        window.Beacon.readyQueue = window.Beacon.readyQueue || [];
        window.Beacon.readyQueue.push({ method: method, options: options, data: data });
    };
    window.Beacon.readyQueue = window.Beacon.readyQueue || [];
    const currentUser = typeof AuthUser !== 'undefined' ? AuthUser : null;
    const HelpScoutScript = document.createElement('script');
    HelpScoutScript.src = 'https://beacon-v2.helpscout.net';
    HelpScoutScript.async = true;
    HelpScoutScript.onload = function() {
        window.Beacon('init', beaconId);
        if (currentUser) {
            window.Beacon('identify', {
                name: _get(currentUser, 'full_name', "Brak uzupełnionej nazwy"),
                email: _get(currentUser, 'email', null),
                signature: _get(currentUser, 'beacon_signature', null),
                instancja: _get(currentUser, 'instance.premium_type', 0) > 0 ? window.location.host : 'Free',
                'nr-su': _get(currentUser, 'instance.uuid_end', null)
            });
        }
    };
    document.head.appendChild(HelpScoutScript);
    window.scriptsLoaded.helpscout = true;
}

export function destroyHelpScout() {
    if (typeof window.Beacon === 'function') {
        try {
            window.Beacon('destroy');
            window.scriptsLoaded.helpscout = false;
        } catch(e) {
            console.error('Error destroying HelpScout Beacon:', e);
        }
    }
}

export const cookieCallbacks = {
    onFirstConsent: (cookie) => {
        if(isEnabled) {
            const acceptedCategories = cookie.categories || [];
            const acceptedServices = Object.values(cookie.services || []).flat();

            if (acceptedCategories.includes(CATEGORY_FUNCTIONALITY) || acceptedServices.includes(SERVICE_HELPSCOUT)) {
                initializeHelpScout();
            }
        }
    },

    onConsent: (cookie) => {
        if(isEnabled) {
            const acceptedCategories = cookie.categories || [];
            const acceptedServices = Object.values(cookie.services || []).flat();

            if (acceptedCategories.includes(CATEGORY_FUNCTIONALITY) || acceptedServices.includes(SERVICE_HELPSCOUT)) {
                initializeHelpScout();
            }
        }
    },

    onChange: (cookie, changedCategories) => {
        if(isEnabled) {
            const acceptedCategories = cookie.categories || [];
            const acceptedServices = Object.values(cookie.services || []).flat();

            if (acceptedCategories.includes(CATEGORY_FUNCTIONALITY) || acceptedServices.includes(SERVICE_HELPSCOUT)) {
                initializeHelpScout();
            } else {
                const revokedCategories = changedCategories.filter(category => !cookie.categories.includes(category));
                if (revokedCategories.includes(CATEGORY_FUNCTIONALITY) && window.scriptsLoaded.helpscout) {
                    destroyHelpScout();
                }
            }
        }
    }
}
